<template>
    <div class="group-savings-table">
        <!-- Main content -->
        <section name="savings">
        <!-- Default box -->
           <div class="card card-outline card-info row">
                <div class="card-body">
                    <table id="example1" class="table table-striped">
                    <thead class="table-custom-header">
                    <tr>
                        <th>View</th>
                        <th>Name</th>
                        <th>Account#</th>
                        <th>Product</th>
                        <th>Ledger Balance</th>
                        <th>Last Transaction</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items">
                            <td>
                                    <router-link :to="{name: 'view-savings-borrower', query: { savings_id: item.id }}" class="btn btn-sm btn-sm btn-success">View</router-link>
                            </td>
                            <td><b>{{item.borrower_name | capitalize}}</b></td>
                            <td>{{item.savings_number}}</td>
                            <td>{{item.savings_product_name}}</td>
                            <td>0</td>
                            <td>N/A</td>
                            <td><button type="button" class="btn btn-warning btn-xs">Overdrawn</button></td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        <!-- /.card -->
        </section>
        <!-- /.content -->
    
    </div>
    </template>
    
    <script>
    export default {
       data() {
            return {
                items:[]
            }
        },
    
        created(){
            this.borrowerGroupSavings()
        },
        methods: {
            async borrowerGroupSavings(){
                let response = await axios.get('api/borrowerGroup/savings/' + this.$route.params.id)
                this.items = response.data
            },
        },
    }
    </script>